export const PRACTICE_KEY = "practice";

export function storePractice(practice) {
  sessionStorage.setItem(PRACTICE_KEY, JSON.stringify(practice));
}

export function getPractice() {
  const practice = sessionStorage.getItem(PRACTICE_KEY);
  if (practice) {
    return JSON.parse(practice);
  }
  return null;
}

export function removePractice() {
  sessionStorage.removeItem(PRACTICE_KEY);
}
